import React from "react";
import ReactDOM from "react-dom";
import Button from "../../../lib/components/Button";
import VerifiedCircleIcon from "../../../lib/components/Icons/VerifiedCircleIcon";
import TextInputContainer from "../../../lib/components/TextInput";

import LayoutModal from "../../common/components/layouts/LayoutModal";
import { AUTH_PROVIDER } from "../../common/constants";

export default function OAuthRegisterModalComponent({
  showModal,
  setShowModal,
  contactInfo,
  authProvider,
  handleSignUp,
  userInfoError,
  userInfo,
  handleOnChange,
  isLoading,
}) {
  return (
    <>
      {ReactDOM.createPortal(
        <LayoutModal
          showModal={showModal}
          setShowModal={setShowModal}
          showCloseIcon={true}
          closeButtonClassnames="top-0 mt-4 left-4"
          shouldCloseOnBackgroundClick={false}
          className={"flex flex-col md:h-auto lg:w-1/3"}
        >
          <div className="flex items-center py-3 px-6 text-center border-b border-space-30">
            <p className="w-full font-serif text-base font-semibold tracking-tight text-space-200">
              Register
            </p>
          </div>

          {/* Modal Body Over Here*/}
          <section
            className="flex overflow-y-auto flex-col flex-grow py-5 px-8 space-y-6"
            id="opt-in-create-batch-modal-body"
          >
            <div className="flex space-x-4">
              <div className="flex-grow-0 w-1/2">
                <p>First Name</p>
                <TextInputContainer
                  placeholder="First Name"
                  name="firstName"
                  onChange={(event) => {
                    handleOnChange({
                      key: event.target.name,
                      value: event.target.value,
                    });
                  }}
                  value={userInfo?.firstName}
                />
                {userInfoError.firstName && (
                  <div>
                    <p className="pt-2 w-full font-serif text-xs text-left md:text-sm text-error">
                      {userInfoError.firstName}
                    </p>
                  </div>
                )}
              </div>

              <div className="flex-grow-0 w-1/2">
                <p>Last Name</p>
                <TextInputContainer
                  placeholder="Last Name"
                  name="lastName"
                  onChange={(event) => {
                    handleOnChange({
                      key: event.target.name,
                      value: event.target.value,
                    });
                  }}
                  value={userInfo?.lastName}
                />
                {userInfoError.lastName && (
                  <div>
                    <p className="pt-2 w-full font-serif text-xs text-left md:text-sm text-error">
                      {userInfoError.lastName}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div>
              <p>
                {authProvider === AUTH_PROVIDER.WHATSAPP ||
                authProvider === AUTH_PROVIDER.SMS
                  ? "Phone no"
                  : "Email"}
              </p>
              <div className="flex flex-row items-center">
                <div className="w-full">
                  <TextInputContainer
                    placeholder="Phone no"
                    value={contactInfo.phone}
                    disabled={true}
                  />
                </div>
                <VerifiedCircleIcon className="flex-shrink-0 ml-2 w-8 h-8 text-primary" />
              </div>
            </div>
          </section>

          {/* Footer  */}
          <div className="flex justify-end py-4 px-6 border-t border-space-30">
            <Button
              onClick={handleSignUp}
              label={"Complete Registration"}
              size="sm"
              disabled={!userInfo.firstName.length}
              isLoading={isLoading}
            />
          </div>
        </LayoutModal>,
        document.getElementById("sub-modal")
      )}
    </>
  );
}
